<template>
    <div
        @click="onClick"
        class="masked-field"
        :class="{ 'is-visible': isVisible }"
        @mouseenter="showMaskedField"
        @mouseleave="hideMaskedField"
        @touchstart="showMaskedField"
        @touchend="hideMaskedField"
    >
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
    import { ref } from "vue";

    const isVisible = ref(false);

    function showMaskedField() {
        isVisible.value = true;
    }
    function hideMaskedField() {
        isVisible.value = false;
    }

    const emit = defineEmits(["click"]);
    function onClick() {
        emit("click");
    }
</script>

<style scoped></style>
